@loaderWidth: 36px;

.report-output-wrapper {
  margin: 20px 0;
}

.report-output {
  border: none;
  width: 100%;
  height: 0;
  &.has-content {
    height: 800px;
  }
}

.loading-icon-wrap {
  width: @loaderWidth;
}

.loading-icon {
  width: @loaderWidth;
  margin: auto;
}

.report-loading {
  display: flex;
}

.error-message {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
}

.error-subtext {
  font-size: 13px;
}

.form-error-message {
  width: 700px;
}
